import { DurationStepField } from '@/forms-legacy'

import { useTexts } from '../hooks/useTexts'

const wrappedInputProps = {
  step: 10,
  min: 0,
}

function secToMin(seconds: number) {
  return Math.round(seconds / 60)
}

function minToSec(minutes: number) {
  return minutes * 60
}

export function MinDrivingTimeSec() {
  const texts = useTexts()

  return (
    <DurationStepField
      name="minWorkingTimeSec"
      testid="minWorkingTimeSec"
      half
      label={texts.minWorkingTimeSec('(hh:mm)')}
      info={texts.minWorkingTimeSecInfo('')}
      parse={minToSec}
      format={secToMin}
      wrappedInputProps={wrappedInputProps}
    />
  )
}
